export default __webpack_public_path__ + "static/media/sticker-n.4be65df7.png";